export const MESSAGE = {
  Loading: 'しばらくお待ちください。...',
  SystemError: 'システムエラーが発生しました。',
  InvalidUser: 'アカウントIDは、必須です。',
  InvalidPassWord: 'パスワードは、必須です。',
  UpdatedSoukouKm: '走行距離が更新されました。',
  UpdatedMemo: 'メモが更新されました。',
  UpdatedOmonaYouto: '主な用途が更新されました。',
  UpdatedFrontTantousha: 'フロントが更新されました。',
  UpdatedConfirmationBeforeEntry: '入庫前確認の情報が更新されました。',
  SaveWorkShubetsu: '表示設定を更新しました',
  SaveNoChangeWorkShubetsu: '更新対象がありません',
  SoukouKmNotEntered: '走行距離が未入力です',
  ExceedStaffSeleced: '整備士と補助整備士の選択が上限(3人)を超えています',
  InvalidJuuryouzei: '重量税が未設定です。',
  InvalidJibaiseiki: '自賠責保険料が未設定です。',
  NoData: "データがありません。"
};
